import { MainBannerForm } from './MainBannerForm'
import { withMainBannerForm } from './withMainBannerForm'

const ConnectedMainBannerForm = withMainBannerForm(MainBannerForm)

export { ConnectedMainBannerForm as MainBannerForm }
